<script lang="ts">
    
    import type { Game } from "../../Model/Game";
    import FigureCheck from "./FigureCheck.svelte";
    import GameTypeText from "./GameTypeText.svelte";

    export let game: Game = undefined;

</script>

{#if game}
    <div class="game-meta-info">
        <div class="game">
            <div class="type"><GameTypeText type={game.type} /></div>
            <div class="code">{game.code}</div>
        </div>
        <div class="figure-check">
            <FigureCheck checkers={game.useCheckers} />
        </div>
    </div>
{/if}

<style lang="scss">

    .game-meta-info {
        display: flex;
        gap: 0.5rem;
        align-items: center;
    }

    .type {
        font-size: 0.8rem;
    }

    .code {
        font-size: 1.5rem;
        line-height: 1em;
    }

</style>
